import FinalRecommendation from "../../Pages/FinalRecommendation";
import { navigationMapBuilder } from "./helpers";

const navigation = [
  {
    header: "Final Recommendation",
    links: [
      {
        text: "Final Recommendation",
        icon: <></>,
        route: "",
        component: FinalRecommendation,
      },
    ],
  },
];

const navigationMap = (parentRoute,layout) =>
  navigationMapBuilder(parentRoute, navigation,layout);


export default navigationMap;
